import { isAdmin, isGuest, isMember } from '@/policies';
export function isSkillsBookDisplayEnabled(user) {
    var _a;
    return ((_a = user === null || user === void 0 ? void 0 : user.user_settings) === null || _a === void 0 ? void 0 : _a.skills_book_display) === true;
}
export function canAccessSkillsRegister(company, user) {
    if (!isSkillsBookDisplayEnabled(user)) {
        return false;
    }
    return isAdmin(company.user_type) || isMember(company.user_type) || isGuest(company.user_type);
}
export function isSkillsRegisterAdmin(company) {
    return isAdmin(company.user_type);
}
